import { useEffect, useMemo, useRef, useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";
import API from "../../Network/API";

const PAGE_SIZE = 8;

export default function JobDetails(props) {
    const modalRef1 = useRef();
    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);

    useEffect(() => {
        if (props.job_id != 0) {
            API.get(`/v1/oauth/jobs/${props.job_id}/view`).then((response) => {
                setData(response.data.data);
                setSearch("");
                setPage(1);
            }).catch(() => {});
        }
    }, [props.job_id]);

    const filteredCards = useMemo(() => {
        const q = search.trim().toLowerCase();
        const cards = data?.cards ?? [];
        if (!q) return cards;
        return cards.filter((c) =>
            String(c.site_id ?? "").toLowerCase().includes(q) ||
            String(c.card_number ?? "").toLowerCase().includes(q)
        );
    }, [data, search]);

    const totalPages = Math.max(1, Math.ceil(filteredCards.length / PAGE_SIZE));

    useEffect(() => {
        if (page > totalPages) setPage(1);
    }, [totalPages, page]);

    const paginatedCards = useMemo(() => {
        const start = (page - 1) * PAGE_SIZE;
        return filteredCards.slice(start, start + PAGE_SIZE);
    }, [filteredCards, page]);

    return (
        <Modal isOpen={props.isModalVisible}
            toggle={props.handleShowB}
            className={'modal-dialog-scrollable modal-lg'} backdrop="static"
            ref={modalRef1}>
            <ModalHeader toggle={props.handleShowB} id={'staticBackdropLabel'}>
                Job Details
            </ModalHeader>
            <ModalBody className="bg-white">
                <table className="table jobTable">
                    <tbody>
                        <tr>
                            <th width={`20%`}>Job Name:</th>
                            <td>{data?.subject}</td>
                        </tr>
                        <tr>
                            <th>Phone Number:</th>
                            <td>{data?.phone_number}</td>
                        </tr>
                        <tr>
                            <th>Card Number:</th>
                            <td>{data?.card_number}</td>
                        </tr>
                        <tr>
                            <th>Assign For:</th>
                            <td>{data?.user_name}</td>
                        </tr>
                        <tr>
                            <th>Organisation:</th>
                            <td>{data?.organization_name}</td>
                        </tr>
                        <tr>
                            <th>Start & End Time:</th>
                            <td>{data?.start_date_txt} {data?.start_time_txt} - {data?.end_date_txt} {data?.end_time_txt}</td>
                        </tr>
                        <tr>
                            <th>Job Status:</th>
                            <td>
                                <span className={`badge ${data?.status == 1 ? 'bg-success' : 'bg-danger'}`}>{data?.status_name}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="card border mt-2">
                    <div className="card-header bg-light p-2 d-flex justify-content-between align-items-center">
                        <strong className="small">
                            Site List <span className="text-muted">({filteredCards.length} of {data?.cards?.length ?? 0})</span>
                        </strong>
                        <div className="input-group input-group-sm" style={{ maxWidth: 260 }}>
                            <span className="input-group-text"><i className="fa fa-search" /></span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search site or card..."
                                value={search}
                                onChange={(e) => { setSearch(e.target.value); setPage(1); }}
                            />
                            {search && (
                                <button type="button" className="btn btn-outline-secondary" onClick={() => setSearch("")}>
                                    <i className="fa fa-times" />
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="table-responsive" style={{ maxHeight: 320 }}>
                        <table className="table table-sm table-hover mb-0 jobTable">
                            <thead className="table-light">
                                <tr>
                                    <th style={{ width: 50 }}>#</th>
                                    <th>SITE ID</th>
                                    <th>Card Number</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedCards.length === 0 && (
                                    <tr>
                                        <td colSpan={4} className="text-center text-muted py-3">
                                            {search ? "No match found" : "No sites added"}
                                        </td>
                                    </tr>
                                )}
                                {paginatedCards.map((row, index) => (
                                    <tr key={`${row.site_id}-${index}`}>
                                        <td>{(page - 1) * PAGE_SIZE + index + 1}</td>
                                        <td>{row.site_id}</td>
                                        <td>{row.card_number}</td>
                                        <td>
                                            <span className={`badge ${row.status == 1 && row.bit_status == 2 ? 'bg-success' : row.status == 1 && row.bit_status == 1 ? 'bg-warning' : 'bg-danger'}`}>
                                                {row?.status_name}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {totalPages > 1 && (
                        <div className="card-footer bg-light p-2 d-flex justify-content-between align-items-center">
                            <small className="text-muted">Page {page} of {totalPages}</small>
                            <div className="btn-group btn-group-sm">
                                <button type="button" className="btn btn-outline-secondary" disabled={page === 1} onClick={() => setPage(1)}>
                                    <i className="fa fa-angle-double-left" />
                                </button>
                                <button type="button" className="btn btn-outline-secondary" disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
                                    <i className="fa fa-angle-left" />
                                </button>
                                <button type="button" className="btn btn-outline-secondary" disabled={page === totalPages} onClick={() => setPage((p) => p + 1)}>
                                    <i className="fa fa-angle-right" />
                                </button>
                                <button type="button" className="btn btn-outline-secondary" disabled={page === totalPages} onClick={() => setPage(totalPages)}>
                                    <i className="fa fa-angle-double-right" />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
}
